var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"input1",attrs:{"placeholder":"Zip/Postal Code","size":"10","type":"text","maxlength":this.country == 'US' ? 5 : 7},on:{"input":function($event){return _vm.validateCode($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }